import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { AppProvider, Frame, TopBar, Button, Navigation, Badge } from '@shopify/polaris';
import axiosRails from "utils/axios-rails";
const propTypes = {
  currentLocation: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  links: PropTypes.array,
  logoURL: PropTypes.string.isRequired,
  userMenu: PropTypes.array,
}

const defaultProps = {
  userMenu: []
}

const AppTopBar = ({ user, ...props }) => {
  // console.log("h",props)
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [navigationSidebar, setNavigationSidebar] = useState(false);
  const linksLength= props.links.length

  // TODO optimize this double map into 1
  const secondaryMenu = props.links.map((link, index)=> {
    if (link.children) {
      return <NavDropdown key={index} link={link} currentLocation={props.currentLocation} />
    }

    return <a className="menu-link" key={index} href={link.url} {...link.data} >
      {link.name}
      { link.count> 0 &&
      <Badge size="small" status="attention">{link.count} </Badge>
      }
    </a>

  })

  // The sidebar has room to list a group's children outright, so it stays flat rather than
  // asking for a second tap.
  const mobileNavigationLinks = [
    { url: "/", label: "Dashboard" },
    ...props.links.flatMap(( link ) => (
      link.children
        ? link.children.map(( child ) => ({ url: child.url, label: `${link.name} · ${child.label || child.name}` }))
        : [{ url: link.url, label: link.name }]
    ))
  ]


  const theme = {
    colors: {
      topBar: {
        background: '#000',
      },
    },
    logo: {
      width: 228,
      topBarSource:
        props.logoURL,
      url: '/',
      accessibilityLabel: 'Unimart Dispatches',
    },
  };

  const handleNavigationToggle = (a) => {
    setNavigationSidebar(!navigationSidebar)
  }
  const logOut=()=>{
    axiosRails.delete("/users/sign_out").then(res=>{
      console.log(res.data)
      location.reload();
    })
  }
  const userMenuMarkup = (
    <TopBar.UserMenu
      name={ `${user.first_name} ${user.last_name || ""}` }
      actions={[ 
        {
          items:props.userMenu
        },
        {
          items: [{content:<a href="/users/sign_out" data-method="delete">Cerrar Sesión </a>}]
        },
      ]}
      initials={ `U` }
      open={isUserMenuOpen}
      onToggle={ () => setIsUserMenuOpen(!isUserMenuOpen) }
    />
  );

  const topBarMarkup = (
    <TopBar
      showNavigationToggle
      userMenu={userMenuMarkup}
      onNavigationToggle={handleNavigationToggle}
      secondaryMenu={secondaryMenu}
    />
  );

  const mobileNavigation = (
    <Navigation location={ props.currentLocation }>
      <Navigation.Section
        items={mobileNavigationLinks}
      />
    </Navigation>
  )

  return (
    <AppProvider
      theme={theme}
    >
      <div id="HeaderFrameContainer">
        <Frame
          topBar={topBarMarkup}
          navigation={ mobileNavigation }
          showMobileNavigation={ navigationSidebar }
          onNavigationDismiss={ handleNavigationToggle }
        >
  
        </Frame>
      </div>
    </AppProvider>
  )
};

// A grouped menu entry. Opens on click rather than hover so it stays reachable by keyboard and on
// touch, and closes on outside click or Escape.
const NavDropdown = ({ link, currentLocation }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onDocumentClick = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) setOpen(false);
    };
    const onKeyDown = (event) => { if (event.key === 'Escape') setOpen(false); };

    document.addEventListener('mousedown', onDocumentClick);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onDocumentClick);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const containsCurrent = link.children.some((child) => child.url === currentLocation);

  return (
    <span className="menu-dropdown" ref={wrapperRef}>
      <button
        type="button"
        className={`menu-link menu-dropdown__activator${containsCurrent ? ' menu-dropdown__activator--current' : ''}`}
        aria-expanded={open}
        aria-haspopup="true"
        onClick={() => setOpen(!open)}
      >
        {link.name}
        <span className="menu-dropdown__caret" aria-hidden="true">▾</span>
      </button>
      {open && (
        <span className="menu-dropdown__list">
          {link.children.map((child, index) => (
            <a
              key={index}
              className={`menu-dropdown__item${child.url === currentLocation ? ' menu-dropdown__item--current' : ''}`}
              href={child.url}
            >
              {child.name}
            </a>
          ))}
        </span>
      )}
    </span>
  );
};

AppTopBar.propTypes = propTypes;
AppTopBar.defaultProps = defaultProps;

export default AppTopBar;